import { Field } from "typegraph";

export default class PagingInfo {
	@Field()
	public totalCount: number;
}


// WEBPACK FOOTER //
// ./src/common/entities/PagingInfo.ts